import React from 'react';
import config from 'config';
import { Base64 } from 'js-base64';
import ButtonLoader from '../ButtonLoader/ButtonLoader';
import LibraryApiCall from 'LibraryApiCall';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ReactHtmlParser from 'react-html-parser';
import { toast } from 'react-toastify';

class AcademicDetails extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      academicYearList: {},
      academicYearSequence: [],
      selectedAcademicYear: config.instructorInfo.AcaYearId,
      selectedDepartment: config.stream_id,
      loadingStreams: false,
      userAssignedStreams: {},
      selectAssignedStream: false,
      tempSelectedDepartment: "",
      iidList: {},
      selectedIid: config.institute_id,
      instituteDetailsFetching: false,
      instituteName: '',
      isDepartmentChangedManually: false,
      loadingInstitute: false,
    };
  }

  componentDidMount() {
    var InstructorDetailsJSON = JSON.parse(Base64.decode(Base64.decode(this.getCookie("user_details"))));
    let yearId = InstructorDetailsJSON["data"]["AcaYearId"];
    let StreamId = InstructorDetailsJSON["data"]["StreamId"];

    this.setState({ selectedAcademicYear: yearId });

    if (StreamId) {
      this.setState({ selectedDepartment: StreamId, isDepartmentChangedManually: true });
    } else {
      this.setState({ isDepartmentChangedManually: false });
    }

    this.apiCallToGetAcademicYearDetails();
    this.apiCallToGetDepartmentDetails();
    this.GetInstructorAssignedInstituteList();
  }
  getCookie = (cname) => {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for (let c of ca) {
      c = c.trim();
      if (c.indexOf(name) === 0)
        return c.substring(name.length, c.length);
    }
    return "";
  }

  async apiCallToGetAcademicYearDetails() {
    let jsonResponse = await LibraryApiCall.makeApiCall(
      'GetAcademicYearListObject',
      { iid: config.institute_id },
      '/api/admission/streamManagement.php'
    );

    if (jsonResponse.success) {
      this.setState({
        academicYearList: jsonResponse.APIResult.data,
        academicYearSequence: jsonResponse.APIResult.sortedIdArray
      });
    } else {
      toast.error('Error fetching academic year details');
    }
  }

  async apiCallToGetDepartmentDetails() {
    this.setState({ loadingStreams: true });
    try {
      let requestData = { faculty_id: config.faculty_id, iid: this.state.selectedIid };
      let jsonResponse = await LibraryApiCall.makeApiCall(
        'getFacultyAssignedStreamList',
        requestData,
        '/api/employeeManagement/employeemanagement.php'
      );

      if (jsonResponse.success) {

        let { selectedDepartment } = this.state;
        let selectedSIDPresnet = false;
        Object.values(jsonResponse.APIResult.data).map((streamOBJ) => {
          if (streamOBJ.streamId == selectedDepartment) {
            selectedSIDPresnet = true;
          }
        })
        if (!selectedSIDPresnet) {
          selectedDepartment = Object.values(jsonResponse.APIResult.data)[0]["streamId"];
        }
        this.setState({ userAssignedStreams: jsonResponse.APIResult.data, selectedDepartment });
      }
    } catch (e) {
      console.log(e);
    } finally {
      this.setState({ loadingStreams: false });
    }
  }

  async GetInstructorAssignedInstituteList() {
    this.setState({ loadingInstitute: true })
    let requestData = { facultyId: config.faculty_id };
    let jsonResponse = await LibraryApiCall.makeApiCall(
      'GetInstructorAssignedInstituteList',
      requestData,
      "/api/management/management.php"
    );

    if (jsonResponse.success) {
      this.setState({ iidList: jsonResponse.APIResult.data, loadingInstitute: false });
    } else {
      toast.error('Something went wrong while fetching institute list');
    }
  }

  closeStreamSelection = () => {
    if (this.state.selectedDepartment === "all") {
      this.setState({ selectAssignedStream: false, selectedDepartment: config.stream_id, tempSelectedDepartment: "" });
    } else {
      this.setState({ selectAssignedStream: false, tempSelectedDepartment: "" });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.selectedIid !== this.state.selectedIid) {
      this.apiCallToGetDepartmentDetails();
    }
    if (
      prevState.selectedIid !== this.state.selectedIid ||
      prevState.selectedAcademicYear !== this.state.selectedAcademicYear ||
      prevState.selectedDepartment !== this.state.selectedDepartment
    ) {
      this.updateUserDetailsCookies();
    }
  }
  changeDepartment = (e) => {
    this.setState({ selectedDepartment: e.target.value, isDepartmentChangedManually: true });
  };

  returnStreamSelectionModal = () => {
    return (
      <div className={this.state.selectAssignedStream ? "modal fade show" : "modal fade"} id="modalContainer">
        <div className="modal-dialog modal-dialog-centered modal-lg streamModal w">
          <div className="modal-content streamSelectionContent workspace-current-modal-mode">
            <div className='modal-header'>
              <h5>Select Stream/Branch</h5>
              <FontAwesomeIcon icon={['fas', 'times']} size="1x" onClick={() => this.setState({ selectAssignedStream: false })} style={{ cursor: "pointer" }} />
            </div>
            <div className="modal-body">
              <table className='table table-bordered workspace-current-modal-mode'>
                <thead>
                  <tr>
                    <th style={{ padding: 5 }}></th>
                    <th style={{ padding: 5 }}>Sr. No.</th>
                    <th style={{ padding: 5 }}>Institute Name</th>
                    <th style={{ padding: 5 }}>Stream Name</th>
                    <th style={{ padding: 5 }}>Institute Short Name</th>
                  </tr>
                </thead>
                <tbody>
                  {Object.keys(this.state.userAssignedStreams).length > 0 ?
                    Object.keys(this.state.userAssignedStreams).map((streamUniqueId, streamIndex) => {
                      let assignedStreamData = this.state.userAssignedStreams[streamUniqueId];
                      return (
                        <tr key={streamIndex}>
                          <td style={{ padding: 5, cursor: 'pointer' }}>
                            <input type="radio" name="assignedStream" value={assignedStreamData.Id} onChange={(e) => this.setState({ tempSelectedDepartment: e.target.value })} />
                          </td>
                          <td style={{ padding: 5 }}>{streamIndex + 1}</td>
                          <td style={{ padding: 5 }}>{ReactHtmlParser(assignedStreamData.instituteName)}</td>
                          <td style={{ padding: 5 }}>{assignedStreamData.Name}</td>
                          <td style={{ padding: 5 }}>{assignedStreamData.instituteShortName}</td>
                        </tr>
                      );
                    })
                    :
                    <tr>
                      <td style={{ padding: 5 }} colSpan={5}>Stream list not available.</td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
            <div className="modal-footer">
              <div style={{ display: 'flex', flexDirection: 'row', gap: '10px' }}>
                <button style={{ cursor: 'pointer' }} className="btn ws-vm-theme-button" onClick={() => this.setState({ selectedDepartment: this.state.tempSelectedDepartment, selectAssignedStream: false })}>Select</button>
                <button style={{ cursor: 'pointer' }} className="btn ws-vm-outlined-button" onClick={() => this.setState({ selectAssignedStream: false })}>Cancel</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  updateUserDetailsCookies = () => {
    let { selectedAcademicYear, academicYearList, selectedDepartment, userAssignedStreams, selectedIid } = this.state;
    let year_text = academicYearList[selectedAcademicYear] ? academicYearList[selectedAcademicYear]["year_text"] : config.instructorInfo['AcaYear'];
    let departmentName = "";
    let assignedStreamDetails = {};

    if (selectedDepartment !== "all") {
      Object.keys(userAssignedStreams).forEach(streamUniqueId => {
        let assignedStreamData = userAssignedStreams[streamUniqueId];
        if (assignedStreamData.Id?.toString() === selectedDepartment?.toString()) {
          departmentName = assignedStreamData.Name;
          assignedStreamDetails = assignedStreamData;
        }
      });

      function setCookie(name, value) {
        document.cookie = name + "=" + (value || "") + "; path=/; ";
      }
      function setWcCookie(name, value) {
        document.cookie = name + "=" + (value || "") + "; path=/;domain=.vmedulife.com";
      }

      if (assignedStreamDetails.instituteName !== undefined) {
        this.setState({ instituteName: assignedStreamDetails.instituteName });
      }

      let InstructorDetailsJSON = JSON.parse(Base64.decode(Base64.decode(this.getCookie("user_details"))));
      InstructorDetailsJSON["data"]["AcaYear"] = year_text;
      InstructorDetailsJSON["data"]["AcaYearId"] = selectedAcademicYear;
      InstructorDetailsJSON["data"]["StreamId"] = selectedDepartment;
      InstructorDetailsJSON["data"]["StreamName"] = departmentName;
      InstructorDetailsJSON["data"]['InstitudeId'] = selectedIid;
      InstructorDetailsJSON["data"]["InstituteName"] = assignedStreamDetails.instituteName;
      InstructorDetailsJSON["data"]["InstituteShortName"] = assignedStreamDetails.instituteShortName;

      if (assignedStreamDetails.instituteShortName) {
        setCookie("user_details", Base64.encode(Base64.encode(JSON.stringify(InstructorDetailsJSON))));
      }
    } else {
      this.setState({ selectAssignedStream: true });
    }
  }

  render() {
    return (
      <div className='subContainers workspace-current-modal-mode' style={{ padding: "14px 14px 20px" }}>
        <p style={{ fontSize: "14px", fontWeight: "bold" }}>Academic Details</p>
        <select className='form-control py-0 mt-2 ws-app-theme-color-20 ws-placeholder-search-text-color' value={this.state.selectedAcademicYear} onChange={(e) => this.setState({ selectedAcademicYear: e.target.value })}>
          {Object.keys(this.state.academicYearList).map(yearId => (
            <option key={yearId} value={yearId}>{this.state.academicYearList[yearId].year_text}</option>
          ))}
        </select>

        <select className='form-control py-0 mt-3 ws-app-theme-color-20 ws-placeholder-search-text-color' value={this.state.selectedIid} onChange={(e) => this.setState({ selectedIid: e.target.value })}>
          {this.state.loadingInstitute ? <ButtonLoader /> :
            Object.values(this.state.iidList).map((institute, index) => (
              <option key={index} value={institute.iid}>{institute.institute_short_code}</option>
            ))}
        </select>

        <select className='form-control py-0 mt-3 ws-app-theme-color-20 ws-placeholder-search-text-color' value={this.state.selectedDepartment} onChange={(e) => this.changeDepartment(e)}>
          {this.state.loadingStreams ? <ButtonLoader /> :
            Object.keys(this.state.userAssignedStreams).map((streamUniqueId, index) => {
              if (index < 15 || this.state.userAssignedStreams[streamUniqueId].Id == this.state.selectedDepartment) {
                return (
                  <option key={streamUniqueId} value={this.state.userAssignedStreams[streamUniqueId].Id}>
                    {this.state.userAssignedStreams[streamUniqueId].Name}
                  </option>

                )
              } else {
                return <></>
              }
            })}
          <option value="all">View All</option>
        </select>
        {this.returnStreamSelectionModal()}
      </div>
    );
  }
}

export default AcademicDetails;
